import { call, put, takeLatest } from "redux-saga/effects";
import {
  onVenueSave,
  onVenueSaveSuccess,
  onVenueSaveError,
  onGetVenue,
  onGetVenueSuccess,
  onGetVenueError,
} from "../Store/Slices/venueSlice";
import { callVenueSaveApi, callGetVenueApi } from "../Context/businessApi";

function* venueSaveSaga({ payload }) {
  try {
    const response = yield call(callVenueSaveApi, payload);
    const code = response.httpStatusCode ?? response.status;
    if (code === "200" || code === 200) {
      yield put(
        onVenueSaveSuccess({
          message: response.message || "Venue saved",
          status_code: code,
        })
      );
    } else {
      yield put(
        onVenueSaveError({
          message: response.message || "Save failed",
          status_code: code,
        })
      );
    }
  } catch (error) {
    const message =
      error.response?.data?.message || error.message || "Something went wrong";
    yield put(onVenueSaveError({ message, status_code: 400 }));
  }
}

function* getVenueSaga() {
  try {
    const response = yield call(callGetVenueApi);
    const code = response.httpStatusCode ?? response.status;
    if (code === "200" || code === 200) {
      const venue = response.data?.venue ?? response.data;
      yield put(
        onGetVenueSuccess({
          data: venue,
          message: response.message || "Venue retrieved",
          status_code: code,
        })
      );
    } else {
      yield put(
        onGetVenueError({
          data: response.data || null,
          message: response.message || "Failed to fetch venue",
          status_code: code,
        })
      );
    }
  } catch (error) {
    const message =
      error.response?.data?.message || error.message || "Something went wrong";
    yield put(onGetVenueError({ data: null, message, status_code: 400 }));
  }
}

export default function* venueSaga() {
  yield takeLatest(onVenueSave.type, venueSaveSaga);
  yield takeLatest(onGetVenue.type, getVenueSaga);
}
